import { Navigate, Route, Routes } from 'react-router-dom';
import AppLayout from '../components/layout/AppLayout';
import LoginPage from '../pages/auth/LoginPage';
import DashboardPage from '../pages/dashboard/DashboardPage';
import SettingsPage from '../pages/settings/SettingsPage';
import AboutPage from '../pages/shared/AboutPage';
import NotFoundPage from '../pages/shared/NotFoundPage';
import MembersPage from '../pages/team/MembersPage';
import RolesAccessPage from '../pages/team/RolesAccessPage';
import AllProjectsPage from '../pages/projects/AllProjectsPage';
import VendorsPage from '../pages/vendors/VendorsPage';
import ExpensesPage from '../pages/expenses/ExpensesPage';
import ProtectedRoute from './guards/ProtectedRoute';
import PublicRoute from './guards/PublicRoute';
import PermissionRoute from './guards/PermissionRoute';
import { PERMISSIONS } from '../constants/permissions';

function AppRouter() {
  return (
    <Routes>
      <Route element={<PublicRoute />}>
        <Route path="/login" element={<LoginPage />} />
      </Route>

      <Route element={<ProtectedRoute />}>
        <Route element={<AppLayout />}>
          <Route path="/" element={<DashboardPage />} />
          <Route element={<PermissionRoute permission={PERMISSIONS.USER_READ} />}>
            <Route path="/access/users" element={<MembersPage />} />
          </Route>
          <Route element={<PermissionRoute permission={PERMISSIONS.ROLE_READ} />}>
            <Route path="/access/roles" element={<RolesAccessPage />} />
          </Route>
          <Route path="/team/members" element={<Navigate to="/access/users" replace />} />
          <Route path="/team/roles" element={<Navigate to="/access/roles" replace />} />
          <Route element={<PermissionRoute permission={PERMISSIONS.PROJECT_READ} />}>
            <Route path="/projects" element={<AllProjectsPage />} />
          </Route>
          <Route path="/projects/create" element={<Navigate to="/projects" replace />} />
          <Route path="/projects/archived" element={<Navigate to="/projects" replace />} />
          <Route element={<PermissionRoute permission={PERMISSIONS.VENDOR_READ} />}>
            <Route path="/vendors" element={<VendorsPage />} />
          </Route>
          <Route element={<PermissionRoute permission={PERMISSIONS.EXPENSE_READ} />}>
            <Route path="/expenses" element={<ExpensesPage />} />
          </Route>
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/dashboard" element={<Navigate to="/" replace />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Route>
    </Routes>
  );
}

export default AppRouter;
